module.exports = __webpack_public_path__ + "static/media/LoyalityProgramCards-1drivene.185cf7d3.png";